import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 px-4 bg-brand-dark relative z-10" data-id="element-174">
      <div className="max-w-3xl mx-auto text-center" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-danger/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_30px_rgba(239,68,68,0.1)]" data-id="element-176">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-5 leading-tight" data-id="element-177">
            Il problema non è il tuo impegno.{' '}
            <span className="text-brand-danger" data-id="element-178">È il sistema.</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-4" data-id="element-179">
            Ogni settimana perdi tra le{' '}
            <span className="text-brand-danger font-bold" data-id="element-180">3 e le 5 ore</span> a
            cercare esercizi su Google, costruire verifiche da zero e scrivere
            griglie di valutazione la domenica sera.
          </p>
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-4" data-id="element-181">
            Sono{' '}
            <span className="text-brand-danger font-bold" data-id="element-182">
              oltre 150 ore all'anno
            </span>{' '}
            sottratte alla tua vita.
          </p>
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-183">
            Mentre pianifichi l'ennesima lezione sulla Partita Doppia, la tua
            passione per l'economia si spegne lentamente sotto il peso della
            burocrazia.
          </p>
        </motion.div>
      </div>
    </section>;
}